// extracted by mini-css-extract-plugin
module.exports = {"mediaSmBreakpoint":"768px","mediaMdBreakpoint":"992px","container":"MenuList_container__1e84L","placeholder":"MenuList_placeholder__2ZJsq"};